export const ourPublicProfilesRoutes = [
  {
    path: '/our-public-profiles',
    name: 'OurPublicProfiles',
    component: () =>
      import(
        /* webpackChunkName: "ourPublicProfiles" */ '@/views/Dashboard/OurPublicProfiles/OurPublicProfiles.vue'
      ),
  },
  {
    path: '/our-public-profiles/:name',
    name: 'OurPublicProfilesProfile',
    component: () =>
      import(
        /* webpackChunkName: "ourPublicProfilesProfile" */ '@/views/Dashboard/OurPublicProfiles/OurPublicProfilesProfile.vue'
      ),
  },
];
